import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { App } from './component';
import registerServiceWorker from './registerServiceWorker';
// import './style.css';

ReactDOM.render(
    <Router >
        <App /> 
    </Router>, 
    document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js